import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Badge from '@repo/ui/badge'
import { ClockIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'

import useTranslate from '../../../../lib/hooks/use-translate'
import OlCenterTabs from '../../ol-common/ol-center-trip-info/ol-center-tabs'

type Props = {
  id: number
  tripBookingReleased?: boolean
}
const OlPersonalSpaceCenterTripsInfo = ({ id, tripBookingReleased }: Props) => {
  const { t } = useTranslate()
  return (
    <div className="mt-5">
      <div className="flex justify-between items-center gap-2">
        <Typography variant="sub-heading" color={tailwindColors.black.DEFAULT}>
          {t('ol.center.trips.info.title')}
        </Typography>
        <Badge
          color={tailwindColors.white.hover}
          borderColor={tailwindColors.grey.light.DEFAULT}
          icon={<ClockIcon />}
          iconPosition="start"
          text={t('ol.center.trips.info.time.note')}
        />
      </div>
      <div className="h-3" />
      <OlCenterTabs id={id} mode="personal-space" tripBookingReleased={tripBookingReleased} />
    </div>
  )
}

export default OlPersonalSpaceCenterTripsInfo
